import each from 'lodash-es/each';

export default (buttons, module_name, index) => {
  let html = '';
  each(buttons, (button, i) => {
    if (button.button_text.length === 0) {
      return;
    }

    const style = button.button_style;
    let custom_style = '';
    let hover_style = '';

    if (style.button_style === 'custom') {
      custom_style = `
        <style>
          #Module-${module_name}--${index}__Button${i}.Button--custom {
            background:${style.button_color};color: ${style.text_color} !important;
          }
        </style>
      `;
      hover_style = `
        <style>
          #Module-${module_name}--${index}__Button${i}.Button--custom:hover {
            background:${style.button_hover_color};color: ${style.text_hover_color} !important;
          }
        </style>
      `;
    }
    html += `
    <a id="Module-${module_name}--${index}__Button${i}" class="Module__Button Button Button--${button.button_style.button_style}" href="${button.button_url}">
      <b>${button.button_text}</b>
    </a>
    ${custom_style}
    ${hover_style}
    `;
  });
  return html;
};
